import { render, staticRenderFns } from "./KampusMerdeka.vue?vue&type=template&id=22cf6a60&scoped=true"
import script from "./KampusMerdeka.vue?vue&type=script&lang=js"
export * from "./KampusMerdeka.vue?vue&type=script&lang=js"
import style0 from "./kampusMerdeka.css?vue&type=style&index=0&id=22cf6a60&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf6a60",
  null
  
)

export default component.exports